var map = {
  "./shape-diamond-aquamarine-gradient.png": "391301",
  "./shape-diamond-aquamarine-light.png": "196021",
  "./shape-diamond-aquamarine.png": "781124",
  "./shape-diamond-blue-gradient.png": "685285",
  "./shape-diamond-blue-light.png": "547609",
  "./shape-diamond-blue.png": "64489",
  "./shape-diamond-cyan-gradient.png": "949642",
  "./shape-diamond-cyan-light.png": "123025",
  "./shape-diamond-cyan.png": "575073",
  "./shape-diamond-green-gradient.png": "912947",
  "./shape-diamond-green-light.png": "601502",
  "./shape-diamond-green.png": "210533",
  "./shape-diamond-grey100.png": "553623",
  "./shape-diamond-grey1000.png": "829401",
  "./shape-diamond-grey200.png": "570714",
  "./shape-diamond-grey25.png": "684754",
  "./shape-diamond-grey300.png": "953080",
  "./shape-diamond-grey400.png": "247910",
  "./shape-diamond-grey50.png": "676476",
  "./shape-diamond-grey500.png": "931581",
  "./shape-diamond-grey600.png": "813376",
  "./shape-diamond-grey700.png": "20034",
  "./shape-diamond-grey800.png": "575183",
  "./shape-diamond-grey900.png": "406049",
  "./shape-diamond-indigo-gradient.png": "481696",
  "./shape-diamond-indigo-light.png": "70152",
  "./shape-diamond-indigo.png": "26278",
  "./shape-diamond-lime-gradient.png": "74398",
  "./shape-diamond-lime-light.png": "663324",
  "./shape-diamond-lime.png": "429477",
  "./shape-diamond-magenta-gradient.png": "842120",
  "./shape-diamond-magenta-light.png": "436378",
  "./shape-diamond-magenta.png": "755027",
  "./shape-diamond-navy-gradient.png": "68632",
  "./shape-diamond-navy-light.png": "404289",
  "./shape-diamond-navy.png": "806509",
  "./shape-diamond-orange-gradient.png": "517305",
  "./shape-diamond-orange-light.png": "402797",
  "./shape-diamond-orange.png": "984070",
  "./shape-diamond-purple-gradient.png": "982885",
  "./shape-diamond-purple-light.png": "834557",
  "./shape-diamond-purple.png": "704196",
  "./shape-diamond-red-gradient.png": "498098",
  "./shape-diamond-red-light.png": "375135",
  "./shape-diamond-red.png": "293373",
  "./shape-diamond-yellow-gradient.png": "69230",
  "./shape-diamond-yellow-light.png": "448435",
  "./shape-diamond-yellow.png": "663020"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578312;
